import React from "react";
import { Heart, Award, Users, Clock } from "lucide-react";

const AboutSection = () => {
  const features = [
    {
      icon: Heart,
      title: "Cuidado Personalizado",
      description: "Tratamentos adaptados às suas necessidades únicas"
    },
    {
      icon: Award,
      title: "Excelência Reconhecida",
      description: "4,925 clientes satisfeitos comprovam a nossa qualidade"
    },
    {
      icon: Users,
      title: "Equipa Especializada",
      description: "Profissionais experientes e certificados"
    },
    {
      icon: Clock,
      title: "Horários Flexíveis",
      description: "Aberto de terça a sábado para sua conveniência"
    }
  ];

  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="space-y-6">
            <div>
              <h2 className="text-4xl md:text-5xl font-playfair font-bold text-sage-dark mb-6">
                Sobre Nós
              </h2>
              <p className="text-lg text-sage-medium leading-relaxed mb-6">
                A Fonte de Juvence é mais do que um centro de estética – é um santuário 
                dedicado ao seu bem-estar e rejuvenescimento. Localizada no coração de Braga, 
                oferecemos uma experiência única que combina técnicas avançadas com o cuidado 
                personalizado que merece.
              </p>
              <p className="text-lg text-sage-medium leading-relaxed">
                Com anos de experiência e uma equipa de profissionais altamente qualificados, 
                criamos um ambiente acolhedor onde pode relaxar, rejuvenescer e redescobrir 
                a sua beleza natural.
              </p>
            </div>
            
            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 pt-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-gold-warm mb-2">4,925</div>
                <div className="text-sage-medium">Clientes Satisfeitos</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-gold-warm mb-2">15+</div>
                <div className="text-sage-medium">Anos de Experiência</div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-3xl shadow-2xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_beauty-rejuvenate/artifacts/l9ztlh72_2023-06-03.webp"
                alt="Ambiente elegante da Fonte de Juvence"
                className="w-full h-96 object-cover transform hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-sage-dark/20 to-transparent"></div>
            </div>
            
            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-gold-warm/20 rounded-full blur-xl"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-aqua-soft/20 rounded-full blur-xl"></div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
          {features.map((feature, index) => (
            <div key={index} className="text-center group">
              <div className="bg-sage-soft/30 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-gold-warm/20 transition-colors duration-300">
                <feature.icon className="w-8 h-8 text-sage-dark group-hover:text-gold-warm transition-colors duration-300" />
              </div>
              <h3 className="text-xl font-semibold text-sage-dark mb-2">{feature.title}</h3>
              <p className="text-sage-medium leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;